import ReactGA from 'react-ga4';

export const sendAnalyticsEvent = (category, action, label) => {
  if (label && Object.keys(label).length > 0) {
    ReactGA.event({
      category: category,
      action: action,
      label: JSON.stringify(label),
    });
  }
};
